
import type { PropType, SetupContext } from 'vue'
import type { CategoriesTreeItem, CategoriesTreeItemRadio, Dictionary } from '../../../models'
import { defineComponent, onMounted } from 'vue'

import { TYPES } from '../../../config/inversify.types'

import { capitalizeSentence } from '../../../filters'

import TransitionSize from '../../transition-size.component.vue'

export default defineComponent({
  name: 'CategoriesItem',
  components: { TransitionSize },
  inject: {
    objectIdService: TYPES.ObjectIdService,
  },
  props: {
    treeCategory: {
      type: Object as PropType<CategoriesTreeItemRadio>,
      required: true,
    },
    lastCategorySelected: Object as PropType<CategoriesTreeItem>,
    messages: {
      type: Object as PropType<Dictionary>,
      required: true,
    },
  },
  setup(props: Record<string, any>, ctx: SetupContext) {
    const baseClass = 'epb-categories-item'
    const { emit } = ctx

    const getIdFromCategory = (category: CategoriesTreeItemRadio): string => {
      return `${baseClass}-${category.id}-${category.level}-${
        category.level > 1 ? category.parentId : ''
      }`
    }

    const onClick = (category: CategoriesTreeItemRadio): void => {
      emit('clickCategory', category)
    }

    onMounted((): void => {
      if (props.treeCategory.selected && props.lastCategorySelected) {
        const { id: treeId, level: treeLevel, parentId: treeParentId } = props.treeCategory
        const { id: lastId, level: lastLevel, parentId: lastParentId } = props.lastCategorySelected
        if (
          treeId === lastId &&
          treeLevel === lastLevel &&
          (lastLevel === 1 || treeParentId === lastParentId)
        ) {
          const element = document.getElementById(
            getIdFromCategory(props.treeCategory as CategoriesTreeItemRadio),
          )
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
            })
          }
        }
      }
    })

    return {
      baseClass,
      getIdFromCategory,
      onClick,
    }
  },
  methods: { capitalizeSentence },
})
